import React, { useState } from 'react';
import { ESSButton } from '../Atoms/ESSButton';
import { ESSTooltip } from '../Atoms/Tooltip';

/**
 * TooltipExample - Functional example of Tooltip component
 * Shows tooltips on hover/focus
 */
const TooltipExample = () => {
  const [activeTooltip, setActiveTooltip] = useState(null);

  const tooltips = [
    {
      id: 'top',
      placement: 'top',
      text: 'Tooltip appears on top',
      label: 'Top',
    },
    {
      id: 'bottom',
      placement: 'bottom',
      text: 'Tooltip appears on bottom',
      label: 'Bottom',
    },
    {
      id: 'left',
      placement: 'left',
      text: 'Tooltip appears on left',
      label: 'Left',
    },
    {
      id: 'right',
      placement: 'right',
      text: 'Tooltip appears on right',
      label: 'Right',
    },
  ];

  return (
    <div className="tooltip-example">
      <div className="tooltip-example__grid">
        {tooltips.map((tooltip) => (
          <div key={tooltip.id} className="tooltip-example__item">
            <div
              className="tooltip-example__trigger"
              onMouseEnter={() => setActiveTooltip(tooltip.id)}
              onMouseLeave={() => setActiveTooltip(null)}
              onFocus={() => setActiveTooltip(tooltip.id)}
              onBlur={() => setActiveTooltip(null)}
              tabIndex={0}
            >
              <ESSButton size="sm">{tooltip.label} Tooltip</ESSButton>
              {activeTooltip === tooltip.id && (
                <div
                  className={`tooltip-example__content tooltip-example__content--${tooltip.placement}`}
                >
                  <ESSTooltip placement={tooltip.placement}>
                    {tooltip.text}
                  </ESSTooltip>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>

      <style jsx>{`
        .tooltip-example__grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
          gap: 2rem;
          padding: 2rem;
        }

        .tooltip-example__item {
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .tooltip-example__trigger {
          position: relative;
          display: inline-block;
        }

        .tooltip-example__content {
          position: absolute;
          z-index: 1000;
          animation: fadeIn 0.2s ease-out;
        }

        .tooltip-example__content--top {
          bottom: 100%;
          left: 50%;
          transform: translateX(-50%);
          margin-bottom: 0.5rem;
        }

        .tooltip-example__content--bottom {
          top: 100%;
          left: 50%;
          transform: translateX(-50%);
          margin-top: 0.5rem;
        }

        .tooltip-example__content--left {
          right: 100%;
          top: 50%;
          transform: translateY(-50%);
          margin-right: 0.5rem;
        }

        .tooltip-example__content--right {
          left: 100%;
          top: 50%;
          transform: translateY(-50%);
          margin-left: 0.5rem;
        }

        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }
      `}</style>
    </div>
  );
};

export default TooltipExample;
